<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='""' class="col-12 bg-primary py-3  text-center" >
                <template #default>   <m-h5 v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>در حال بروز رسانی    </template>
                </m-h5></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="text-center container my-4" >
                <template #default>   <m-p v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>محتوا در حال بروزرسانی است .   </template>
                </m-p><m-a v-bind='{...{"href":"{\"name\":\"Home\",\"params\":{}}","target":"_self"},...{}}' :style='""' class="btn btn-primary px-5 m-5" >
                <template #default>بازگشت    </template>
                </m-a></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mH5 from '@moeinmdn/miw-alpha-components/src/package/Tags/H5'; import mP from '@moeinmdn/miw-alpha-components/src/package/Tags/P'; import mA from '@moeinmdn/miw-alpha-components/src/package/Tags/A';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mH5,mP,mA },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
